export default __webpack_public_path__ + "static/media/technology.3a4b051f.png";